// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CharitableTrustDesignerBeneficiaries_EntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type CharitableTrustDesignerBeneficiaries_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string };

export type CharitableTrustDesignerBeneficiaries_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string };

export type CharitableTrustDesignerBeneficiaries_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string };

export type CharitableTrustDesignerBeneficiaries_HouseholdFragment = { __typename?: 'Household', id: string, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & CharitableTrustDesignerBeneficiaries_EntityFragment
      ) | null } | null> | null }, clientProfiles?: Array<(
    { __typename?: 'ClientProfile' }
    & CharitableTrustDesignerBeneficiaries_ClientProfileFragment
  )> | null, clientOrganizations?: Array<(
    { __typename?: 'ClientOrganization' }
    & CharitableTrustDesignerBeneficiaries_ClientOrganizationFragment
  )> | null, testamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & CharitableTrustDesignerBeneficiaries_TestamentaryEntityFragment
      ) | null } | null> | null } };

export type CharitableTrustDesignerBeneficiariesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type CharitableTrustDesignerBeneficiariesQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & CharitableTrustDesignerBeneficiaries_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    CharitableTrustDesignerBeneficiaries: 'CharitableTrustDesignerBeneficiaries' as const
  },
  Fragment: {
    CharitableTrustDesignerBeneficiaries_Entity: 'CharitableTrustDesignerBeneficiaries_Entity' as const,
    CharitableTrustDesignerBeneficiaries_ClientProfile: 'CharitableTrustDesignerBeneficiaries_ClientProfile' as const,
    CharitableTrustDesignerBeneficiaries_ClientOrganization: 'CharitableTrustDesignerBeneficiaries_ClientOrganization' as const,
    CharitableTrustDesignerBeneficiaries_TestamentaryEntity: 'CharitableTrustDesignerBeneficiaries_TestamentaryEntity' as const,
    CharitableTrustDesignerBeneficiaries_Household: 'CharitableTrustDesignerBeneficiaries_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableTrustDesignerBeneficiaries_EntityFragmentDoc = gql`
    fragment CharitableTrustDesignerBeneficiaries_Entity on Entity {
  id
  kind
  subtype {
    id
    displayName
  }
}
    `;
export const CharitableTrustDesignerBeneficiaries_ClientProfileFragmentDoc = gql`
    fragment CharitableTrustDesignerBeneficiaries_ClientProfile on ClientProfile {
  id
  displayName
}
    `;
export const CharitableTrustDesignerBeneficiaries_ClientOrganizationFragmentDoc = gql`
    fragment CharitableTrustDesignerBeneficiaries_ClientOrganization on ClientOrganization {
  id
  name
}
    `;
export const CharitableTrustDesignerBeneficiaries_TestamentaryEntityFragmentDoc = gql`
    fragment CharitableTrustDesignerBeneficiaries_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
}
    `;
export const CharitableTrustDesignerBeneficiaries_HouseholdFragmentDoc = gql`
    fragment CharitableTrustDesignerBeneficiaries_Household on Household {
  id
  entities {
    edges {
      node {
        ...CharitableTrustDesignerBeneficiaries_Entity
      }
    }
  }
  clientProfiles {
    ...CharitableTrustDesignerBeneficiaries_ClientProfile
  }
  clientOrganizations {
    ...CharitableTrustDesignerBeneficiaries_ClientOrganization
  }
  testamentaryEntities {
    edges {
      node {
        ...CharitableTrustDesignerBeneficiaries_TestamentaryEntity
      }
    }
  }
}
    ${CharitableTrustDesignerBeneficiaries_EntityFragmentDoc}
${CharitableTrustDesignerBeneficiaries_ClientProfileFragmentDoc}
${CharitableTrustDesignerBeneficiaries_ClientOrganizationFragmentDoc}
${CharitableTrustDesignerBeneficiaries_TestamentaryEntityFragmentDoc}`;
export const CharitableTrustDesignerBeneficiariesDocument = gql`
    query CharitableTrustDesignerBeneficiaries($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        ...CharitableTrustDesignerBeneficiaries_Household
      }
    }
  }
}
    ${CharitableTrustDesignerBeneficiaries_HouseholdFragmentDoc}`;

/**
 * __useCharitableTrustDesignerBeneficiariesQuery__
 *
 * To run a query within a React component, call `useCharitableTrustDesignerBeneficiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharitableTrustDesignerBeneficiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharitableTrustDesignerBeneficiariesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCharitableTrustDesignerBeneficiariesQuery(baseOptions?: Apollo.QueryHookOptions<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>(CharitableTrustDesignerBeneficiariesDocument, withFetchPolicyContext(options));
      }
export function useCharitableTrustDesignerBeneficiariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>(CharitableTrustDesignerBeneficiariesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCharitableTrustDesignerBeneficiariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>(CharitableTrustDesignerBeneficiariesDocument, withFetchPolicyContext(options));
        }
export type CharitableTrustDesignerBeneficiariesQueryHookResult = ReturnType<typeof useCharitableTrustDesignerBeneficiariesQuery>;
export type CharitableTrustDesignerBeneficiariesLazyQueryHookResult = ReturnType<typeof useCharitableTrustDesignerBeneficiariesLazyQuery>;
export type CharitableTrustDesignerBeneficiariesSuspenseQueryHookResult = ReturnType<typeof useCharitableTrustDesignerBeneficiariesSuspenseQuery>;
export type CharitableTrustDesignerBeneficiariesQueryResult = Apollo.QueryResult<CharitableTrustDesignerBeneficiariesQuery, CharitableTrustDesignerBeneficiariesQueryVariables>;